import {
  ICON_DEFAULT_COLOR,
  ICON_DEFAULT_FILL,
  ICON_DEFAULT_HEIGHT,
  ICON_DEFAULT_VIEWBOX,
  ICON_DEFAULT_WIDTH,
  IconProps
} from 'components'
import { ComponentProps } from 'react'

export const PostOn = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = ICON_DEFAULT_WIDTH,
  height = ICON_DEFAULT_HEIGHT,
  viewBox = ICON_DEFAULT_VIEWBOX,
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M31.0447 24.4101L48 5.62466L44.5835 2.36084L31.2339 17.1513L27.1023 12.0505L23.5206 15.1212L31.0447 24.4101Z"
        fill={color}
      />
      <path
        d="M38.7842 5.13121C36.5869 3.65295 33.9607 2.79354 31.1393 2.79354C23.4146 2.79354 17.1524 9.23601 17.1524 17.1832C17.1524 25.1304 23.4146 31.5729 31.1393 31.5729C38.864 31.5729 45.1262 25.1304 45.1262 17.1832C45.1262 15.9203 44.968 14.6953 44.671 13.5282L40.3864 18.4259C39.7941 23.137 35.8798 26.7763 31.1393 26.7763C25.9895 26.7763 21.8147 22.4813 21.8147 17.1832C21.8147 11.8851 25.9895 7.5901 31.1393 7.5901C32.7585 7.5901 34.2813 8.0147 35.6083 8.76158L38.7842 5.13121Z"
        fill={color}
      />
      <path
        d="M17.7462 7.5901L6.95387 7.5901C5.64117 7.59393 4.38329 8.13212 3.45507 9.08707C2.52685 10.042 2.00373 11.3361 2 12.6866V43.2643C2.00373 44.6148 2.52685 45.9089 3.45507 46.8639C4.38329 47.8188 5.64117 48.357 6.95387 48.3608H36.6756C37.9883 48.357 39.2462 47.8188 40.1744 46.8639C41.1026 45.9089 41.6257 44.6148 41.6295 43.2643V30.0431C40.251 31.2344 38.6783 32.1955 36.9672 32.8688V43.5643H6.66229V12.3866H15.497C15.9983 10.6541 16.764 9.03867 17.7462 7.5901Z"
        fill={color}
      />
      <path
        d="M14.8315 17.7824H11.907V22.8789H15.7844C15.2236 21.2789 14.8923 19.5661 14.8315 17.7824Z"
        fill={color}
      />
      <path
        d="M25.8547 33.0712C27.5121 33.6546 29.2898 33.9712 31.1393 33.9712C31.3343 33.9712 31.5284 33.9676 31.7217 33.9607V38.1678H11.907V33.0712H25.8547Z"
        fill={color}
      />
      <path
        d="M16.9208 25.4268C18.0104 27.4117 19.4813 29.1456 21.2313 30.5234H11.907V25.4268H16.9208Z"
        fill={color}
      />
    </svg>
  )
}
